import React from 'react';
import { Paper, Typography, Divider, Grid, Box } from '@mui/material';

/**
 * Mirrors the "SAVINGS SUMMARY" block layout:
 * Savings B/F, Savings Refund, Savings Offset, Proc Charges, Total,
 * Contributions, Savings C/F.
 */
const Row = ({ label, value, bold, color }) => (
  <>
    <Grid item xs={7}>
      <Typography variant="body2" sx={bold ? { fontWeight: 'bold' } : undefined}>
        {label}
      </Typography>
    </Grid>
    <Grid item xs={5}>
      <Typography
        variant="body2"
        align="right"
        sx={{ ...(bold ? { fontWeight: 'bold' } : {}), ...(color ? { color } : {}) }}
      >
        {value}
      </Typography>
    </Grid>
  </>
);

const SavingsSummary = ({ savingsSummary, formatCurrency }) => {
  const s = savingsSummary || {};

  return (
    <Paper sx={{ p: 2, height: '100%' }} data-testid="savings-summary">
      <Typography variant="h6" gutterBottom color="primary">
        SAVINGS SUMMARY
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Box sx={{ mb: 2 }}>
        <Grid container spacing={1}>
          <Row label="Savings B/F" value={formatCurrency(s.savingsBF)} />
          <Row label="Savings Refund" value={formatCurrency(s.savingsRefund)} />
          <Row label="Savings Offset" value={formatCurrency(s.savingsOffset)} />
          <Row label="Proc Charges" value={formatCurrency(s.procCharges)} />
          <Row label="Total" value={formatCurrency(s.total)} bold />
          <Row label="Contributions" value={formatCurrency(s.contributions)} />
          <Row
            label="Savings C/F"
            value={formatCurrency(s.savingsCF)}
            bold
            color="error.main"
          />
        </Grid>
      </Box>
    </Paper>
  );
};

export default SavingsSummary;